import React from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { RefreshCw } from 'lucide-react';

/**
 * Card de status de atualização — read-only, usado no /master.
 * Recebe `updateStatus` (payload de /api/updates/status) e uma função
 * opcional de formatação de data.
 */
export const UpdateStatusCard = ({ updateStatus, fmtDate }) => {
  if (!updateStatus) return null;
  return (
    <Card className="p-4" data-testid="master-update-card">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <RefreshCw className="text-blue-600" size={20} />
          <div className="text-lg font-semibold">Atualizações do Sistema</div>
        </div>
        {updateStatus.pending_approval ? (
          <Badge className="bg-amber-500 text-white" data-testid="master-update-badge">AGUARDANDO EXECUÇÃO</Badge>
        ) : updateStatus.update_available ? (
          <Badge className="bg-blue-600 text-white" data-testid="master-update-badge">NOVA VERSÃO DISPONÍVEL</Badge>
        ) : (
          <Badge className="bg-slate-500 text-white" data-testid="master-update-badge">EM DIA</Badge>
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-3">
        <div>
          <div className="text-xs text-slate-500">Versão atual</div>
          <div className="font-mono text-sm">{updateStatus.current_version} <span className="text-slate-400">({updateStatus.channel})</span></div>
        </div>
        <div>
          <div className="text-xs text-slate-500">Última verificação</div>
          <div className="text-sm">{updateStatus.last_check_at ? fmtDate(updateStatus.last_check_at) : 'Nunca'}</div>
        </div>
        <div>
          <div className="text-xs text-slate-500">Versão nova</div>
          <div className={`font-bold ${updateStatus.update_available ? 'text-blue-600' : 'text-slate-800'}`}>
            {updateStatus.latest_version || '—'}
          </div>
        </div>
        <div>
          <div className="text-xs text-slate-500">Aprovada</div>
          <div className="text-sm">
            {updateStatus.pending_approval
              ? `Sim — por ${updateStatus.approved_by || '—'}`
              : 'Não'}
          </div>
        </div>
      </div>
      {updateStatus.changelog && (
        <div className="mt-3 p-3 bg-slate-50 rounded text-xs whitespace-pre-wrap" data-testid="master-update-changelog">
          <div className="font-bold text-slate-700 mb-1">Novidades</div>
          {updateStatus.changelog}
        </div>
      )}
      {updateStatus.update_available && !updateStatus.pending_approval && (
        <p className="text-[11px] text-blue-700 mt-3">
          💡 Para aprovar: abra a página <a href="/license" className="underline">Licença Local</a> (logado como admin) e clique em <strong>Aprovar Atualização</strong>. O update roda na próxima janela do agendador Windows.
        </p>
      )}
      {updateStatus.pending_approval && (
        <p className="text-[11px] text-amber-700 mt-3">
          ⏳ Atualização aprovada. Ela será executada pelo Windows Task Scheduler
          (CHECK_UPDATE.bat) em até 1 hora. Faça backup adicional se preciso.
        </p>
      )}
    </Card>
  );
};
